
import Factory from "@/store/modules/system/factory/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins} from "@/lib";
@Component({
})
export default class CreateFactory extends Mixins(FormModalMixins) {
    model: Factory = new Factory();
    created(){
        Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:100, okAction:"system/factory/create"});
    }

    mounted(){
        // (this.$refs["form-modal"] as any).resetFields();
    }

    
}
